import api from '@/api'

let Q = require('q')

const state = {
  estados: []
}

const getters = {
  estados: (state) => {
    return state.estados
  }
}

const mutations = {
  SET_ESTADOS (state, estados) {
    state.estados = estados
  }
}

const actions = {
  async fetchEstadosMedio ({ commit }) {
    let deferred = Q.defer()
    try {
      const response = await api.medio.getEstadosMedios()
      commit('SET_ESTADOS', response.data)

      deferred.resolve()
    } catch (err) {
      console.error(err)
      deferred.reject(err)
    }

    return deferred.promise
  }
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
